import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import cfg from "./cfg";
import store from "./store";

Vue.config.productionTip = false;

// Global variables
Vue.prototype.$cfg = cfg;

// axios
// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = cfg.API_URL;

// POST with JSON content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// It gives you easy global access to it instead use import
Vue.prototype.$axios = axios.create();

axios
  .get(cfg.ACCOUNTS_API_URL + "users")
  .then(response => {
    store.commit("SET_USER", response.data);
  })
  .catch(() => {
    store.commit("SET_USER", null);
  })
  .then(() => {
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  });
